// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const amoonguss: PokeData = {
  "id": 591,
  "name": "amoonguss",
  "height": 6,
  "weight": 105,
  "base_experience": 162,
  "types": [
    PokeType.GRASS,
    PokeType.POISON
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "growth",
    "solar-beam",
    "stun-spore",
    "toxic",
    "bide",
    "spore",
    "feint-attack",
    "giga-drain",
    "sweet-scent",
    "synthesis",
    "ingrain",
    "astonish",
    "rage-powder",
    "clear-smog"
  ],
  "moves": [
    "solar-beam",
    "stun-spore",
    "synthesis",
    "leaf-tornado",
    "razor-leaf",
    "sludge-bomb",
    "poison-jab",
    "toxic-spikes",
    "venom-drench",
    "grassy-terrain",
    "mortal-gas",
    "branch-poke",
    "poison-powder"
  ],
  "evolution_chain": {
    "id": 300,
    "item": null,
    "species": [
      {
        "name": "foongus",
        "order": 591,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "amoonguss",
        "order": 592,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 590,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 39,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 180,
    "speed": 57,
    "ability_power": 162
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
